import React from 'react'
import { 
  Button, 
  HStack, 
  Text, 
  Avatar, 
  useColorModeValue
} from '@chakra-ui/react'
import { useAuthContext } from '../../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'

export const UserMenu: React.FC = () => {
  const { user, signOut, isAuthenticated } = useAuthContext()
  const navigate = useNavigate()
  
  const textColor = useColorModeValue('white', 'white')
  const buttonBg = useColorModeValue('#3182ce', '#3182ce')
  const buttonHoverBg = useColorModeValue('#2c5aa0', '#2c5aa0')

  const handleSignOut = async () => {
    try {
      await signOut()
      navigate('/')
    } catch (error) {
      console.error('Sign out error:', error)
    }
  }

  if (!isAuthenticated) {
    return (
      <HStack spacing={4}>
        <Button
          variant="ghost"
          color={textColor}
          _hover={{ bg: 'whiteAlpha.100' }}
          onClick={() => navigate('/auth')}
          size={{ base: "sm", md: "md" }}
        >
          Log In
        </Button>
        <Button
          bg={buttonBg}
          color="white"
          _hover={{ bg: buttonHoverBg }}
          onClick={() => navigate('/auth?mode=register')}
          borderRadius="2"
          size={{ base: "sm", md: "md" }}
        >
          Sign Up
        </Button>
      </HStack>
    )
  }

  return (
    <Button
      variant="ghost"
      color={textColor}
      _hover={{ bg: 'whiteAlpha.100' }}
      onClick={() => navigate('/profile')}
    >
      <HStack spacing={2}>
        <Avatar size="sm" bg={buttonBg} name={user?.displayName} />
        <Text display={{ base: 'none', md: 'block' }}>{user?.displayName}</Text>
      </HStack>
    </Button>
  )
} 